/*
 * Public API Surface of catalean-storage
 */

export * from './lib/catalean-storage.service';
export * from './lib/catalean-storage.module';
